import { AppState } from '../AppTypes';

export const _isBrandAuthorised = (state: AppState) => {
  return (brandId: string) => {
    const accessLevel = state?.userInfo?.accessLevel;
    const brandIds = state?.userInfo?.brandIds;
    if (accessLevel === 'SaleCycle') {
      return true;
    } else if (accessLevel === 'Brand') {
      return brandIds && brandIds.includes(brandId);
    } else {
      //If user is Site or MultiSite level they don't have access to the brand
      return false;
    }
  };
};
